import type { ReactElement } from 'react';

import cambridgeLogoUrl from '../assets/cambridge-approved-by.svg';
import learnPlusOnLightUrl from '../assets/learnplus-wordmark-on-light.svg';

/** Horizontal Learn Plus lockup for white auth cards (login, registration, staff). */
export function AuthWordmark(): ReactElement {
  return (
    <div className="auth-brand-header">
      <img className="auth-wordmark" src={learnPlusOnLightUrl} alt="Learn Plus" />
    </div>
  );
}

/** Cambridge mark on a light field, as on the enrollment card mock. */
export function AuthEndorsement(): ReactElement {
  return (
    <div className="auth-endorsement">
      <img
        className="auth-endorsement-mark"
        src={cambridgeLogoUrl}
        alt="Cambridge International Education"
      />
    </div>
  );
}
